import { SavedView } from "types";
import Modal from "views/atomComponents/Modal";
import TrashIcon from "assets/icons/TrashIcon";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { deleteSavedView, fetchSavedViews } from "redux/SingleDataset/actions";
import { ReactNode, useRef, useState } from "react";
import { Id, toast } from "react-toastify";
import VLToastComponent from "views/components/VLToastComponent";
import { amplitudeTrack } from "helpers/utility/amplitude";
import { AMP_SAVED_VIEWS_EVENT__VIEW_DELETED } from "helpers/constants/amplitudeEvents";
import styles from "./style.module.scss";

interface DeleteViewModalProps {
  view: SavedView;
  onCloseModal: () => void;
}

export const DeleteViewModal = ({
  view,
  onCloseModal,
}: DeleteViewModalProps) => {
  const dispatch = useDispatch();
  const { viewsDatasetId } = useParams();
  const [deletingViewInProgress, setDeletingViewInProgress] =
    useState<boolean>(false);
  const toastIdRef = useRef<any>(null);

  const showToast = (Element: ReactNode): Id => {
    return toast(Element, {
      closeButton: false,
      closeOnClick: false,
      position: "bottom-center",
    });
  };

  const successNotification = () => {
    toastIdRef.current = showToast(
      <VLToastComponent
        status="SUCCESS"
        title={'View "' + view.name + '" deleted!'}
        onClose={() => toast.dismiss(toastIdRef.current)}
        description={
          "Your view has been successfully deleted. You cannot access it anymore."
        }
      />,
    );
  };
  const handleDeleteConfirm = async () => {
    setDeletingViewInProgress(true);
    const response = await dispatch(
      deleteSavedView(view.id, viewsDatasetId) as any,
    );
    setDeletingViewInProgress(false);
    onCloseModal();
    if (response.status === 200) {
      amplitudeTrack(AMP_SAVED_VIEWS_EVENT__VIEW_DELETED);
      successNotification();
      dispatch(fetchSavedViews(viewsDatasetId) as any);
    }
  };
  return (
    <Modal
      title="Delete View"
      subtitle="Are you sure you want to delete this view?"
      description="Selecting this action will permanently remove the view and all their related information"
      titleIcon={
        <div className={styles.trashIcon}>
          <TrashIcon />
        </div>
      }
      primaryLoading={deletingViewInProgress}
      onPrimaryActionClick={handleDeleteConfirm}
      onSecondaryActionClick={onCloseModal}
    />
  );
};
